var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgX(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00005 9.02423L12.097 13.1212C12.3798 13.404 12.8384 13.404 13.1212 13.1212C13.404 12.8383 13.404 12.3798 13.1212 12.0969L9.02428 8L13.1212 3.90304C13.404 3.62021 13.404 3.16164 13.1212 2.87881C12.8384 2.59597 12.3798 2.59597 12.097 2.87881L8.00005 6.97577L3.90303 2.87879C3.6202 2.59596 3.16163 2.59596 2.87879 2.87879C2.59596 3.16163 2.59596 3.6202 2.87879 3.90304L6.97574 8L2.87879 12.097C2.59596 12.3798 2.59596 12.8383 2.87879 13.1212C3.16163 13.404 3.6202 13.404 3.90303 13.1212L8.00005 9.02423Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.31dba54f3c69211dc8b71a625e75fa42.svg";
export { ForwardRef as ReactComponent };